<template>
    <div class="wl-container">
        <div class="wl-content-container">
            <!-- 搜索框 -->
            <div class="wl-search-bar">
                <div :class="['search-collapse', showSearchParams ? 'show-search-params' : '']">
                    <div @click="showSearchParams = !showSearchParams" style="cursor: pointer">
                        <template v-if="showSearchParams">{{ $t('hide_search_conditions') }} <i class="el-icon-arrow-up" /> </template>
                        <template v-else>{{ $t('show_search_conditions') }}<i class="el-icon-arrow-down" /></template>
                    </div>

                    <div v-if="showSearchParams">
                        <el-select
                            class="masterCode-sel-cls"
                            v-model="masterCodeLists"
                            multiple
                            filterable
                            clearabled
                            collapse-tags
                            reserve-keyword
                            remote
                            :remote-method="masterCodeRemote"
                            :placeholder="$t('SITE_CODE_PLACEHOLDER')"
                            :loading="masterCodeLoading"
                            @visible-change="remoteVisibleChange"
                            @remove-tag="getStaffList"
                        >
                            <el-option
                                v-for="item in masterCodeOptions"
                                :key="item.id"
                                :label="item.engagementMasterCode + '[' + item.siteName + ']'"
                                :value="item.engagementMasterCode"
                            >
                            </el-option>
                        </el-select>
                        <el-select
                            v-model="codeType"
                            class="wl-select input-with-select"
                            clearable
                            :placeholder="$t('table_header_label_code_type')"
                        >
                            <el-option v-for="item in codeTypeOptions" :key="item.value" :label="item.label" :value="item.value">
                            </el-option>
                        </el-select>
                        <el-input
                            :placeholder="$t('SITE_SEARCH_NAME_KEYWORD')"
                            v-model="searchContent"
                            maxlength="100"
                            clearable
                            class="input-with-select"
                        >
                        </el-input>
                        <el-input
                            :placeholder="$t('SITE_SEARCH_CLIENT_KEYWORD')"
                            v-model="clientName"
                            maxlength="100"
                            clearable
                            class="input-with-select"
                        >
                        </el-input>
                        <el-select
                            v-model="ifRollForward"
                            class="input-with-select select-boolean"
                            clearable
                            :placeholder="$t('RolledForward')"
                        >
                            <el-option :value="false" label="否" />
                            <el-option :value="true" label="是" />
                        </el-select>
                        <el-select v-model="ownerShip" class="input-with-select" filterable clearable :placeholder="$t('SITE_OWNER_SHIP')">
                            <el-option v-for="item in ownerShipOpt" :key="item.code" :label="item.value" :value="item.value"> </el-option>
                        </el-select>
                        <el-select
                            v-model="serviceGroup"
                            class="input-with-select select2"
                            filterable
                            clearable
                            :placeholder="$t('SITE_SERVICE_GROUP')"
                        >
                            <el-option v-for="item in serviceGroupOpt" :key="item.code" :label="item.value" :value="item.value">
                            </el-option>
                        </el-select>
                        <el-select
                            v-model="siteFlag"
                            class="input-with-select select-boolean"
                            clearable
                            :placeholder="$t('SITE_TABLE_HEADER_IS_LLP')"
                        >
                            <el-option value="0" label="否" />
                            <el-option value="1" label="是" />
                        </el-select>
                        <el-input
                            :placeholder="$t('client_user_email_keyword')"
                            v-model="clientUser"
                            maxlength="100"
                            clearable
                            class="input-with-select"
                        >
                        </el-input>
                        <input-number-range
                            class="input-with-select"
                            :value="subEntitiesCountList"
                            @changeFrom="changeFrom"
                            @changeTo="changeTo"
                            :fromPlaceholder="$t('SITE_SEARCH_ENTITY')"
                            :toPlaceholder="$t('SITE_SEARCH_ENTITY')"
                        />
                        <el-select
                            v-model="userNameVal"
                            filterable
                            remote
                            reserve-keyword
                            clearable
                            :placeholder="$t('SITE_TABLE_HEADER_SITE_ADMIN')"
                            :remote-method="queryUserNameSearch"
                            :loading="userLoading"
                            class="input-with-select"
                        >
                            <el-option
                                v-for="item in userOpt"
                                :key="item.email"
                                :label="item.userName + '(' + item.profitCenter + ')'"
                                :value="item.email"
                            >
                            </el-option>
                        </el-select>
                        <el-select
                            v-model="memberVal"
                            filterable
                            remote
                            reserve-keyword
                            clearable
                            :placeholder="$t('PAGE_KPMG_TEAM_TITLE')"
                            :remote-method="queryMemberSearch"
                            :loading="memberLoading"
                            class="input-with-select"
                        >
                            <el-option
                                v-for="item in memberOpt"
                                :key="item.email"
                                :label="item.userName + '(' + item.profitCenter + ')'"
                                :value="item.email"
                            >
                            </el-option>
                        </el-select>
                        <!--项目合伙人-->
                        <el-select
                            v-model="siteOwnerVal"
                            filterable
                            remote
                            reserve-keyword
                            clearable
                            :placeholder="$t('SITE_LABEL_SITE_OWNER')"
                            :remote-method="querySiteOwnerSearch"
                            :loading="siteOwnerLoading"
                            class="input-with-select"
                        >
                            <el-option
                                v-for="item in siteOwnerOpt"
                                :key="item.email"
                                :label="item.userName + '(' + item.profitCenter + ')'"
                                :value="item.email"
                            >
                            </el-option>
                        </el-select>
                        <!--项目管理员-->
                        <el-select
                            v-model="siteManagerVal"
                            filterable
                            remote
                            reserve-keyword
                            clearable
                            :placeholder="$t('SITE_LABEL_SITE_MANGER')"
                            :remote-method="querySiteManagerSearch"
                            :loading="siteManagerLoading"
                            class="input-with-select"
                        >
                            <el-option
                                v-for="item in siteManagerOpt"
                                :key="item.email"
                                :label="item.userName + '(' + item.profitCenter + ')'"
                                :value="item.email"
                            >
                            </el-option>
                        </el-select>
                        <el-date-picker
                            v-model="closeDateRange"
                            type="daterange"
                            clearable
                            :range-separator="$t('SITE_TO')"
                            value-format="yyyy-MM-dd"
                            :start-placeholder="$t('SITE_CLOSE_DATE')"
                            :end-placeholder="$t('SITE_CLOSE_DATE')"
                            class="input-with-select date-range"
                        >
                        </el-date-picker>
                        <el-date-picker
                            v-model="dateRange"
                            type="daterange"
                            clearable
                            :range-separator="$t('SITE_TO')"
                            value-format="yyyy-MM-dd"
                            :start-placeholder="$t('create_date')"
                            :end-placeholder="$t('create_date')"
                            class="input-with-select date-range"
                        >
                        </el-date-picker>
                        <el-button icon="el-icon-search" class="wl-green" @click="searchSite">{{ $t('btn_search') }}</el-button>
                        <el-button class="cancel-btn" @click="resetTable">{{ $t('COMMON_CLEAR_BTN') }}</el-button>
                    </div>
                </div>

                <div class="wl-right">
                    <el-button class="wl-green" icon="el-icon-plus" @click="onAddAccount">{{ $t('COMMON_ADD') }} </el-button>
                    <el-button @click="downloadSites" class="wl-green svg-btn"
                        ><img src="@/assets/img/icon-export.svg" class="btn-icon" width="100%" />{{ $t('SITE_DOWNLOAD_SITE') }}
                    </el-button>
                    <!--<el-button class="wl-green svg-btn" @click="handleIBSSync" :disabled="iBSSyncLoading">
                        <img src="@/assets/img/icon-import.svg" class="btn-icon" width="100%" v-if="!iBSSyncLoading"/>
                        <i class="el-icon-loading" v-else></i>
                        {{ $t('sync_from_IBS') }}
                    </el-button>-->
                    <el-button @click="download" class="wl-green" icon="el-icon-download">{{ $t('COMMON_DOWNLOAD_TEMP') }} </el-button>
                    <el-upload
                        class="template-uploader"
                        action="url"
                        :http-request="uploadFiles"
                        :show-file-list="false"
                        :on-success="handleAvatarSuccess"
                        :before-upload="beforeAvatarUpload"
                    >
                        <el-button class="wl-green svg-btn"
                            ><img src="@/assets/img/icon-import.svg" width="100%" class="btn-icon" />{{ $t('COMMON_IMPORT') }}</el-button
                        >
                    </el-upload>
                </div>
            </div>
            <!-- 表格 -->
            <div class="table-out-wrap">
                <div :class="['table-container-wrapper site-table-wrap', showSearchParams ? 'show-table-bottom-operate' : '']">
                    <el-table height="100%" v-loading="loading" :data="data" class="wl-user-table" border stripe>
                        <el-table-column type="index" width="70"></el-table-column>

                        <el-table-column
                            prop="engagementMasterCode"
                            width="110"
                            :label="$t('SITE_TABLE_HEADER_ENGAGEMENT_CODE')"
                        ></el-table-column>
                        <el-table-column width="180" :label="$t('table_header_label_code_type')">
                            <template slot-scope="scope">
                                {{
                                    codeTypeOptions.find((v) => v.value == scope.row.codeType)
                                        ? codeTypeOptions.find((v) => v.value == scope.row.codeType).label
                                        : ''
                                }}
                            </template>
                        </el-table-column>

                        <el-table-column prop="siteName" show-overflow-tooltip width="160" :label="$t('SITE_TABLE_HEADER_SITE_NAME')">
                        </el-table-column>
                        <el-table-column
                            prop="clientName"
                            width="130"
                            show-overflow-tooltip
                            :label="$t('FORM_LABEL_clientName')"
                        ></el-table-column>
                        <el-table-column width="130" show-overflow-tooltip :label="$t('RolledForward')">
                            <template slot-scope="scope">
                                {{ scope.row.ifRollForward ? $t('COMMON_YES') : $t('COMMON_NO') }}
                            </template>
                        </el-table-column>

                        <el-table-column prop="codeCloseDatetime" width="160" :label="$t('SITE_CLOSE_DATE')"></el-table-column>

                        <el-table-column prop="ownerShip" width="170" :label="$t('SITE_OWNER_SHIP')"></el-table-column>

                        <el-table-column prop="serviceGroup" width="200" :label="$t('SITE_SERVICE_GROUP')"></el-table-column>

                        <el-table-column width="130" :label="$t('SITE_TABLE_HEADER_IS_LLP')">
                            <template slot-scope="scope">
                                {{ scope.row.siteFlag === '1' ? $t('COMMON_YES') : $t('COMMON_NO') }}
                            </template>
                        </el-table-column>

                        <el-table-column
                            prop="subEntitiesCount"
                            width="150"
                            :label="$t('SITE_TABLE_HEADER_NUMBER_OF_ENTITIES')"
                        ></el-table-column>

                        <el-table-column
                            prop="userNameList"
                            min-width="150"
                            show-overflow-tooltip
                            :label="$t('SITE_TABLE_HEADER_SITE_ADMIN')"
                        ></el-table-column>

                        <el-table-column width="180" show-overflow-tooltip :label="$t('PAGE_KPMG_TEAM_TITLE')">
                            <template slot-scope="scope">
                                {{ scope.row.memberList.map((member) => member.userName + '(' + member.profitCenter + ')').join('; ') }}
                            </template>
                        </el-table-column>

                        <el-table-column width="180" show-overflow-tooltip :label="$t('SITE_LABEL_SITE_OWNER')">
                            <template slot-scope="scope">
                                {{
                                    scope.row.siteOwner.id && scope.row.siteOwner.id !== ''
                                        ? scope.row.siteOwner.userName + '(' + scope.row.siteOwner.profitCenter + ')'
                                        : ''
                                }}
                            </template>
                        </el-table-column>

                        <el-table-column width="180" show-overflow-tooltip :label="$t('SITE_LABEL_SITE_MANGER')">
                            <template slot-scope="scope">
                                {{
                                    scope.row.siteManager.id && scope.row.siteManager.id !== ''
                                        ? scope.row.siteManager.userName + '(' + scope.row.siteManager.profitCenter + ')'
                                        : ''
                                }}
                            </template>
                        </el-table-column>

                        <el-table-column width="180" show-overflow-tooltip :label="$t('TABLE_HEADER_CLIENTUSER')">
                            <template slot-scope="scope">
                                {{ scope.row.clientUserList.map((member) => member.userAccount).join('; ') }}
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="createBy"
                            show-overflow-tooltip
                            width="200"
                            :label="$t('SITE_TABLE_HEADER_CREATE_BY')"
                        ></el-table-column>

                        <el-table-column prop="createDate" width="160" :label="$t('SITE_TABLE_HEADER_CREATE_TIME')"></el-table-column>

                        <el-table-column
                            prop="updateBy"
                            show-overflow-tooltip
                            width="200"
                            :label="$t('SITE_TABLE_HEADER_MODIFIED_BY')"
                        ></el-table-column>

                        <el-table-column prop="action" width="120" align="center" fixed="right" :label="$t('TABLE_HEADER_Action')">
                            <template slot-scope="scope">
                                <i class="el-icon-edit-outline wl-icon-edit" aria-hidden="true" @click="onEditAccount(scope.row)"></i>

                                <i class="el-icon-delete wl-icon-delete" @click="onDeleteAccount(scope.row)"></i>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>

                <!-- 分页 -->
                <el-pagination
                    class="wl-pagination"
                    :current-page="pagination.pageNum"
                    :page-size="pagination.pageSize"
                    @current-change="onCurrentPageChange"
                    @size-change="onSizeChange"
                    :page-sizes="[10, 50, 100]"
                    layout="prev, pager, next,sizes,total"
                    :total="pagination.total"
                ></el-pagination>
            </div>
        </div>
        <!-- 新增/修改的弹框 -->
        <site-add
            v-if="addVisible"
            :onCancel="toggleAddVisible"
            :defaultValue="currentRow"
            :editLoading="editLoading"
            :onAddOrEdit="addOrEditSite"
        />
        <!-- s删除的弹框 -->
        <site-delete v-if="deleteVisible" :data="currentRow" :onCancel="toggleDeleteVisible" :onDelete="deleteSite" />
    </div>
</template>
<script>
import SelectAd from '@/components/common/selectAd'
import API from '@/api'
import { deleteConfirm, loading, dateFormat, isIE, UserInput } from '@/utils'
import SiteAdd from './site-add'
import SiteDelete from './site-delete'
import SiteEmail from './site-email'
import InputNumberRange from '@/components/common/InputNumberRange'

export default {
    name: 'user',
    data() {
        return {
            showSearchParams: false,
            data: [],
            emailBtnLoading: false,
            pagination: {
                pageNum: 1,
                pageSize: 10,
                total: 0
            },
            loading: false,
            // iBSSyncLoading: false,
            masterCodeLoading: false,
            masterCodeLists: [],
            masterCodeOptions: [],
            remoteTimeOut: null,
            searchContent: '',
            addVisible: false,
            deleteVisible: false,
            currentRow: {},
            dateRange: [],
            closeDateRange: [],
            fileParams: new FormData(),
            codeType: '',
            codeTypeOptions: [
                {
                    label: this.$t('site_code_type_long_master'),
                    value: '0'
                },
                {
                    label: this.$t('site_code_type_long_sub'),
                    value: '1'
                },
                {
                    label: this.$t('site_code_type_long_opp'),
                    value: '2'
                },
                {
                    label: this.$t('site_code_type_long_bd'),
                    value: '3'
                }
            ],
            clientName: '',
            ifRollForward: null,
            siteFlag: null,
            subEntitiesCountList: [null, null],
            userNameVal: '',
            memberVal: '',
            siteOwnerVal: '',
            siteManagerVal: '',
            timer: null,
            userOpt: [],
            userLoading: false,
            memberOpt: [],
            memberLoading: false,
            siteOwnerOpt: [],
            siteOwnerLoading: false,
            siteManagerOpt: [],
            siteManagerLoading: false,
            clientUser: '',
            ownerShip: '',
            ownerShipOpt: [],
            serviceGroup: '',
            serviceGroupOpt: [],
            editLoading: false
        }
    },
    mounted() {
        this.getOwnerShip()
        this.getServiceGroup()
        this.getStaffList()
    },
    methods: {
        getOwnerShip() {
            API.common.getDict({ dictName: 'owner_ship' }).then((res) => {
                if (res.code === '1') {
                    this.ownerShipOpt = res.data
                }
            })
        },
        getServiceGroup() {
            API.common.getDict({ dictName: 'service_group' }).then((res) => {
                if (res.code === '1') {
                    this.serviceGroupOpt = res.data
                }
            })
        },
        queryUserNameSearch: _.debounce(function (query) {
            if (query.trim() !== '') {
                this.userLoading = true
                let param = {
                    searchContent: query,
                    sysUserRoleType: 'R003'
                }
                API.system.queryUserListByName(param).then((res) => {
                    if (res.code === '1') {
                        this.userOpt = res.data
                        this.userLoading = false
                    }
                })
            } else {
                this.userOpt = []
            }
        }),
        queryMemberSearch: _.debounce(function (query) {
            if (query.trim() !== '') {
                this.memberLoading = true
                let param = {
                    searchContent: query,
                    sysUserRoleType: 'R004'
                }
                API.system.queryUserListByName(param).then((res) => {
                    if (res.code === '1') {
                        this.memberOpt = res.data
                        this.memberLoading = false
                    }
                })
            } else {
                this.memberOpt = []
            }
        }),
        querySiteOwnerSearch: _.debounce(function (query) {
            if (query.trim() !== '') {
                this.siteOwnerLoading = true
                let param = {
                    searchContent: query,
                    sysUserRoleType: 'R001'
                }
                API.system.queryUserListByName(param).then((res) => {
                    if (res.code === '1') {
                        this.siteOwnerOpt = res.data
                        this.siteOwnerLoading = false
                    }
                })
            } else {
                this.siteOwnerOpt = []
            }
        }),
        querySiteManagerSearch: _.debounce(function (query) {
            if (query.trim() !== '') {
                this.siteManagerLoading = true
                let param = {
                    searchContent: query,
                    sysUserRoleType: 'R002'
                }
                API.system.queryUserListByName(param).then((res) => {
                    if (res.code === '1') {
                        this.siteManagerOpt = res.data
                        this.siteManagerLoading = false
                    }
                })
            } else {
                this.siteManagerOpt = []
            }
        }),
        /*handleIBSSync() {
            this.iBSSyncLoading = true
            API.system.syncIBSInfo().then(res => {
                if(res.code === '1') {
                    this.$message.success(this.$t('msg_success'))
                } else {
                    this.$message.error(this.$t(res.code))
                }
            }).catch(e => {}).finally(() => {
                this.iBSSyncLoading = false
            })
        },*/
        async download() {
            try {
                const res = await API.system.downloadSiteTemplate()
                if (res) {
                    let blob = new Blob([res])
                    if (isIE()) {
                        navigator.msSaveBlob(blob, 'SiteTemplate.xlsx')
                    } else {
                        let url = window.URL.createObjectURL(blob)
                        let link = document.createElement('a')
                        link.style.display = 'none'
                        link.href = url
                        link.setAttribute('download', 'SiteTemplate.xlsx')
                        document.body.appendChild(link)
                        link.click()
                    }
                }
            } catch (e) {
            } finally {
            }
        },
        async downloadSites() {
            let service = loading()
            try {
                service.download()
                const res = await API.system.exportSite({
                    siteName: this.searchContent,
                    dateRange: this.dateRange,
                    closeDateRange: this.closeDateRange,
                    siteAdminEmail: this.userNameVal,
                    kpMemberEmail: this.memberVal,
                    partnerEmail: this.siteOwnerVal,
                    siteManagerEmail: this.siteManagerVal,
                    clientName: this.clientName,
                    ifRollForward: this.ifRollForward,
                    codeType: this.codeType,
                    siteFlag: this.siteFlag,
                    clientUser: this.clientUser,
                    subEntitiesCountList: this.subEntitiesCountList,
                    ownerShip: this.ownerShip,
                    serviceGroup: this.serviceGroup
                })
                if (/application\/json/.test(res.type)) {
                    let reader = new FileReader()
                    reader.onload = (e) => {
                        if (e.target.readyState === 2) {
                            let resJson = {}
                            resJson = JSON.parse(e.target.result)
                            this.$message.error({ duration: 5000, message: this.$t(resJson.code) })
                        }
                    }
                    reader.readAsText(res)
                } else if (/application\/octet-stream/.test(res.type)) {
                    let blob = new Blob([res])
                    if (isIE()) {
                        navigator.msSaveBlob(blob, 'Site.xlsx')
                    } else {
                        let url = window.URL.createObjectURL(blob)
                        let link = document.createElement('a')
                        link.style.display = 'none'
                        link.href = url
                        link.setAttribute('download', 'Site.xlsx')
                        document.body.appendChild(link)
                        link.click()
                    }
                }
            } catch (e) {
            } finally {
                service.close()
            }
        },
        uploadFiles(item) {
            this.fileParams = new FormData()
            this.fileParams.append('file', item.file)
            this.upload()
        },
        async upload() {
            let service = loading()
            const _this = this
            try {
                service.upload()
                const response = await API.system.importSiteTemplate(this.fileParams)
                if (response) {
                    const { code, data, errDetails } = response
                    if (code === '1') {
                        let lock = false
                        const interval = setInterval(() => {
                            if (lock) return
                            API.system.queryImport(data).then((innerResult) => {
                                lock = true
                                const reader = new FileReader()
                                reader.onload = function () {
                                    try {
                                        let jsonData = JSON.parse(this.result || 'false')
                                    } catch (err) {
                                        clearInterval(interval)
                                        const blob = new Blob([innerResult])
                                        if (isIE()) {
                                            navigator.msSaveBlob(blob, 'SiteImportResult.xlsx')
                                        } else {
                                            let link = document.createElement('a')
                                            link.style.display = 'none'
                                            link.href = window.URL.createObjectURL(blob)
                                            link.setAttribute('download', 'SiteImportResult.xlsx')
                                            document.body.appendChild(link)
                                            link.click()
                                            document.body.removeChild(link)
                                        }
                                        _this.getStaffList()
                                    } finally {
                                        lock = false
                                    }
                                }
                                reader.readAsText(innerResult)
                            })
                        }, 5000)
                    } else {
                        this.$message.error(errDetails.msg)
                    }
                }
            } catch (e) {
            } finally {
                service.close()
            }
        },
        handleAvatarSuccess(res, file) {},
        beforeAvatarUpload(file) {
            const isExcel =
                file.type === 'application/vnd.ms-excel' ||
                file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
                file.type === 'image/png'
            const isLt2M = file.size / 1024 / 1024 < 5

            if (!isExcel) {
                this.$message.error(this.$t('import_file_type_error'))
            }
            if (!isLt2M) {
                this.$message.error(this.$t('import_file_size_error'))
            }
            return isExcel && isLt2M
        },
        onAddAccount() {
            this.currentRow = {}
            this.toggleAddVisible()
        },
        async onEditAccount(row) {
            this.currentRow = row
            await this.queryLimits(row.siteId)
            this.toggleAddVisible()
        },
        // 查询站点downloadable
        async queryLimits(siteId) {
            const { code, data } = await API.clientUser.getSiteConfig({ param: siteId })
            if (code == '1') {
                this.currentRow.downloadAble = !!data.downloadable
            } else {
                this.$message.error(this.$t(code))
            }
        },
        onDeleteAccount(row) {
            this.currentRow = row
            deleteConfirm(
                this.$t('site_delete_notice', {
                    code: row.engagementMasterCode,
                    siteName: row.siteName,
                    clientName: row.clientName
                })
            ).then(() => this.toggleDeleteVisible())
        },
        resetTable() {
            this.masterCodeLists = []
            this.codeType = ''
            this.searchContent = ''
            this.clientName = ''
            this.ifRollForward = null
            this.siteFlag = null
            this.clientUser = ''
            this.subEntitiesCountList = [null, null]
            this.userNameVal = ''
            this.memberVal = ''
            this.siteOwnerVal = ''
            this.siteManagerVal = ''
            this.dateRange = []
            this.closeDateRange = []
            this.serviceGroup = ''
            this.ownerShip = ''
            this.searchSite()
        },
        searchSite: _.debounce(
            function () {
                if (this.searchContent && !UserInput.reg1.test(this.searchContent)) {
                    this.$message.error(this.$t('ILLEGAL_USER_INPUT_02'))
                    return
                }
                this.onCurrentPageChange(1)
            },
            500,
            { leading: true }
        ),
        onSizeChange(size) {
            this.pagination.pageSize = size
            this.pagination.pageNum = 1
            this.getStaffList()
        },
        onCurrentPageChange(current) {
            this.pagination.pageNum = current
            this.getStaffList()
        },
        toggleAddVisible() {
            this.addVisible = !this.addVisible
        },
        toggleDeleteVisible() {
            this.deleteVisible = !this.deleteVisible
        },
        changeFrom(val) {
            this.subEntitiesCountList[0] = val
        },
        changeTo(val) {
            this.subEntitiesCountList[1] = val
        },
        getStaffList: async function () {
            try {
                this.loading = true
                const params = {
                    ...this.pagination,
                    masterCodeLists: this.masterCodeLists,
                    siteName: this.searchContent,
                    dateRange: this.dateRange,
                    closeDateRange: this.closeDateRange,
                    siteAdminEmail: this.userNameVal,
                    kpMemberEmail: this.memberVal,
                    partnerEmail: this.siteOwnerVal,
                    siteManagerEmail: this.siteManagerVal,
                    clientName: this.clientName,
                    ifRollForward: this.ifRollForward,
                    codeType: this.codeType,
                    siteFlag: this.siteFlag,
                    clientUser: this.clientUser,
                    subEntitiesCountList: this.subEntitiesCountList,
                    ownerShip: this.ownerShip,
                    serviceGroup: this.serviceGroup
                }
                const { code, data, errDetails } = await API.system.querySiteList(params)
                if (code === '1') {
                    this.data = _.map(data.records, (v) => {
                        return {
                            ...v,
                            userNameList: _.map(v.userList, (v) => v.userName + '(' + v.profitCenter + ')').join('; '),
                            createDate: v.createDateStamp ? dateFormat(new Date(+v.createDateStamp)) : '--',
                            updateDate: v.updateDateStamp ? dateFormat(new Date(+v.updateDateStamp)) : '--'
                        }
                    })
                    this.pagination.total = data.total

                    this.loading = false
                } else {
                    this.$message.error(this.$t(code))
                }
            } catch (e) {
            } finally {
                this.loading = false
            }
        },
        addOrEditSite: async function (form) {
            try {
                this.editLoading = true
                const api = form.siteId === '' ? API.system.addSite : API.system.updateSite
                const { code, data, errDetails } = await api(form)
                this.editLoading = false
                if (code === '1') {
                    this.toggleAddVisible()
                    await this.getStaffList()
                } else {
                    if (code === 'ROLE_003') {
                        const startIndex = errDetails.msg ? errDetails.msg.indexOf('[') : null
                        const endIndex = errDetails.msg ? errDetails.msg.indexOf(']') : null
                        const security_admin =
                            errDetails.msg && startIndex && startIndex !== -1 && endIndex && endIndex !== -1
                                ? errDetails.msg.substring(startIndex + 1, endIndex)
                                : null
                        this.$message({
                            dangerouslyUseHTMLString: true,
                            type: 'error',
                            message: this.$t('ROLE_003', { security_admin: security_admin })
                        })
                    } else {
                        this.$message({
                            dangerouslyUseHTMLString: true,
                            type: 'error',
                            message: this.$t(code)
                        })
                    }
                }
            } catch (e) {
            } finally {
            }
        },
        deleteSite: async function (form) {
            let service = loading()
            try {
                service.load()

                const params = {
                    ...form,
                    siteId: this.currentRow.siteId
                }

                const { code, data, errDetails } = await API.system.deleteSite(params)
                if (code === '1') {
                    this.toggleDeleteVisible()
                    await this.getStaffList()
                } else {
                    this.$message.error(this.$t(code))
                }
            } catch (e) {
            } finally {
                service.close()
            }
        },
        masterCodeRemote: async function (query) {
            if (query.length < 2) {
                this.masterCodeOptions = []
            } else {
                // 带着字段远程获取option
                // this.getMasterCodeOpt(query)
                this.masterCodeLoading = true
                if (this.remoteTimeOut) {
                    clearTimeout(this.remoteTimeOut)
                }
                this.remoteTimeOut = setTimeout(() => {
                    API.system.queryMasterCodeList({ masterCode: query }).then((res) => {
                        if (res.code === '1') {
                            this.remoteList = res.data
                            this.masterCodeLoading = false
                            this.masterCodeOptions = res.data
                        }
                    })
                }, 500)
            }
        },
        remoteVisibleChange(show) {
            if (!show) {
                this.masterCodeOptions = []
                this.getStaffList()
            }
        }
    },
    components: {
        SelectAd,
        SiteAdd,
        SiteDelete,
        SiteEmail,
        InputNumberRange
    }
}
</script>

<style scoped>
.wl-container {
    height: 100%;
    background: #eff1f5;
    padding: 22px;
}

.wl-content-container {
    background: #fff;
    height: 100%;
    padding: 22px 22px 16px 22px;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
}

.wl-search-bar {
    font-size: 12px;
    color: #333333;
    margin-bottom: 10px;
    min-height: 50px;
}
.table-out-wrap {
    flex: 1;
    height: 100%;
}
.search-collapse {
    /* height: 39px; */
    /* transition: height 0.3s; */
    font-size: 12px;
    overflow: hidden;
    border-top: 1px solid #ebeef5;
    border-bottom: 1px solid #ebeef5;
}
.search-collapse > div:nth-child(1) {
    margin: 5px 0;
}
.search-collapse.show-search-params {
    /* height: calc(90px + 65px); */
}
.wl-left,
.wl-right {
    margin-top: 5px;
    display: flex;
    justify-content: flex-end;
    justify-items: center;
}

.masterCode-sel-cls {
    margin-right: 15px;
    width: 220px;
    margin-bottom: 10px;
}
::v-deep .masterCode-sel-cls .el-input .el-input__inner {
    height: 30PX !important;
}
.masterCode-sel-cls ::v-deep .el-select__tags-text {
    display: inline-block;
    max-width: 80px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.masterCode-sel-cls ::v-deep .el-tag__close.el-icon-close {
    top: -6px;
}

.input-with-select {
    width: 230px;
    margin-right: 15px;
    margin-bottom: 10px;
    display: inline-block;
}
.input-with-select.date-range {
    width: 330px;
    display: inline-flex;
}
.input-with-select.select2 {
    width: 280px;
}
.select-boolean {
    width: 180px;
}
.template-uploader {
    margin-left: 10px;
}

.wl-left .wl-green {
    margin-left: 5px;
}
.table-container-wrapper.site-table-wrap {
    /* height: calc(100% - 50px); */
}
.table-container-wrapper.show-table-bottom-operate {
    /* height: calc(100% - 117px - 125px); */
}
</style>
